import { useMemo } from 'react';
import pluralize from 'pluralize';

export const getMovementsHeader = (movementsCount) =>
  `${movementsCount?.toLocaleString()} ${pluralize('movement', movementsCount ?? 0)}`;

export const useMovementsColumns = ({ movementsTotal = 0, isLoading = false } = {}) =>
  useMemo(
    () => [
      {
        Header: isLoading ? 'Loading...' : getMovementsHeader(movementsTotal),
        accessor: 'contact',
        width: 200,
        hide: false,
        pinned: 'left',
        cellRenderer: 'movementContactRenderer',
        suppressMovable: true,
        disableSortBy: true,
        show: true,
        hideOnTableColumn: true,
        valueFormatter: ({ data: { original } }) => original.contact?.fullName || '',
      },
      {
        Header: 'Company',
        accessor: 'company',
        width: 200,
        disableSortBy: true,
        disablePadding: true,
        cellRenderer: 'movementCompanyRenderer',
        show: true,
        valueFormatter: ({ data: { original } }) => original.organization?.name || original.companyName || '',
      },
      {
        Header: 'Job title',
        accessor: 'jobTitle',
        width: 240,
        disableSortBy: true,
        disablePadding: true,
        cellRenderer: 'movementJobTitleRenderer',
        show: true,
        valueFormatter: ({ data: { original } }) => original.jobTitle || '',
      },
      {
        Header: 'Type',
        accessor: 'movementType',
        width: 140,
        disableSortBy: true,
        disablePadding: true,
        cellRenderer: 'movementTypeBadge',
        show: true,
        valueFormatter: ({ data: { original } }) => original.movementType || '',
      },
      {
        Header: 'Date',
        accessor: 'date',
        width: 160,
        disableSortBy: false,
        disablePadding: true,
        cellRenderer: 'movementDateRenderer',
        show: true,
        valueFormatter: ({ data: { original } }) => original.date || '',
      },
    ],
    [],
  );
